import { get } from "lodash";
import { APPLY, SET_APPLIED } from "actions/tool-panel/applied/constants";
import { PayloadParam } from "actions/utilities/payload-param-type";
import { handleActions } from "redux-actions";
import { getStore } from "store";
import { DimensionsPanelReduxState } from "../dimensions-panel";
import { SetApplied } from "actions/tool-panel/applied/types";
import { SYNC_RECEIVED_UPDATES_WITH_DIMENSION_PANEL_STATE } from "actions/tool-panel/draft/constants";
import { syncAllocationDimensionUpdates } from "../draft/handlers";

export const applied = handleActions(
    {
        [APPLY]: () => {
            const reduxState = getStore()?.getState();
            const dimensionsPanelDraft = get(reduxState, "dimensionsPanel.draft");
            return { ...dimensionsPanelDraft };
        },
        [SET_APPLIED]: (_state: DimensionsPanelReduxState, { payload }: PayloadParam<SetApplied>) => {
            return { ...payload };
        },
        [SYNC_RECEIVED_UPDATES_WITH_DIMENSION_PANEL_STATE]: syncAllocationDimensionUpdates,
    },
    null,
);
